export {
  clientAuth as auth,
  onAuthStateChanged,
  signOut,
} from './clientAppAuth';

export const browserLocalPersistence = { type: 'LOCAL' };
export const browserSessionPersistence = { type: 'SESSION' };

export async function setPersistence() {
  return undefined;
}

export function getAuth() {
  return require('./clientAppAuth').clientAuth;
}

export async function signInWithEmailAndPassword(_auth, email, password) {
  const { loginClientWithPassword } = await import('../api/localAuth');
  await loginClientWithPassword(email, password);
  const { clientAuth } = await import('./clientAppAuth');
  return { user: clientAuth.currentUser };
}

export async function createUserWithEmailAndPassword(_auth, email, password) {
  const { registerSession } = await import('../api/localAuth');
  await registerSession({ email, password, kind: 'client' });
  const { clientAuth } = await import('./clientAppAuth');
  return { user: clientAuth.currentUser };
}

export async function signInWithPopup() {
  throw new Error('Google sign-in is not available');
}

export class GoogleAuthProvider {}
export class EmailAuthProvider {
  static credential(email, password) {
    return { email, password };
  }
}

export async function reauthenticateWithCredential(_user, credential) {
  const { loginClientWithPassword } = await import('../api/localAuth');
  await loginClientWithPassword(credential.email, credential.password);
}

export async function updatePassword() {
  throw new Error('Use changePassword with the current password');
}

export async function verifyBeforeUpdateEmail() {
  return undefined;
}

export async function signInAnonymously() {
  return { user: null };
}
